/**
 * Facets are needed to populate the source selection dropdown
 * It populates both the sources and their respective result counts
 * We only need to fetch the sources once, but we need to update the counts each time a "full" search is done
 */
export interface LPRResultsFacets {
  cameraVendors: LPRResultsCameraVendor[];
}

export interface LPRResultsCameraVendor {
  vendor: string;
  count: number;
  cameraModels: LPRResultsCameraModel[];
}

export interface LPRResultsCameraModel {
  model: string;
  count: number;
}
